import { createContext } from "react";

export const DeviceOutputContext = createContext({
    isApp: false,
});

export default DeviceOutputContext;
